<template>
  <div class="form-group">
    <label
      :for="`input-shopper-custprop-${Guid}-${_uid}`"
      class="col-md-3 control-label"
      :class="{ 'text-red': Recommended && value === undefined }"
      @click.prevent="updateValue()"
    >
      {{ Title }}
      <span v-if="Recommended">*</span>
    </label>
    <div class="col-md-9">
      <button
        class="btn-checkbox pull-left"
        :class="{ 'checkbox-readonly': readOnly }"
        @click.prevent="updateValue()"
      >
        <i class="material-icons md-24">
          <span v-if="value === true">check_box</span>
          <span v-else-if="value === false">check_box_outline_blank</span>
          <span v-else>indeterminate_check_box</span>
        </i>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "CheckboxInput",
  props: {
    Title: String,
    Guid: String,
    Recommended: { type: Boolean, default: false },
    value: { type: Boolean, default: undefined },
    readOnly: { type: Boolean, default: false },
  },
  methods: {
    updateValue() {
      if (this.readOnly) return;
      let result;
      if (this.value === true) result = false;
      else if (this.value === false) result = undefined;
      else result = true;
      this.$emit("input", result);
    },
  },
};
</script>

<style scoped>
.btn-checkbox {
  border: none;
  background: none;
  min-height: 45px;
  padding: 0;
}
.checkbox-readonly {
  color: darkgray;
  cursor: not-allowed;
}
</style>



// WEBPACK FOOTER //
// CheckboxInput.vue?5b5c9a81